// extracted by mini-css-extract-plugin
module.exports = {"packageWrapper":"buypackage_packageWrapper__3jAFb","bonus":"buypackage_bonus__26ZDH","desc":"buypackage_desc__2s7y1","buyButton":"buypackage_buyButton__3rD9w"};